/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_EditInputs */

const he_posts_edit = /** @type {(inputs: Posts_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוך פוסט`)
};

const en_posts_edit = /** @type {(inputs: Posts_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Post`)
};

/**
* | output |
* | --- |
* | "Edit Post" |
*
* @param {Posts_EditInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_edit = /** @type {((inputs?: Posts_EditInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_EditInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_edit(inputs)
	return en_posts_edit(inputs)
});